import { Component } from '@angular/core';
import { LoaderService } from "../core/services/loader.service";
import { Observable } from "rxjs";
import { SplashScreen } from '@capacitor/splash-screen';
import { SafeArea } from 'capacitor-plugin-safe-area';
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent {
  loading$: Observable<boolean>;
  isPublicLanding: boolean = false;

  constructor(private loaderService: LoaderService, private router: Router) {
    this.loading$ = this.loaderService.updateLoader$;
    this.isPublicLanding = this.router.url.startsWith('/festive-login');
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.isPublicLanding = e.urlAfterRedirects.startsWith('/festive-login');
      });
    this.splashScreenHandler().then(()=>{});
  }
  async adjustLayout(){
      const {insets}=await SafeArea.getSafeAreaInsets();
      document.documentElement.style.setProperty('--safe-top',`${insets.top}px`);
  }
  async splashScreenHandler() {
    await this.adjustLayout();
    await SplashScreen.show({
      showDuration: 3000,
      autoHide: true
    });

    setTimeout(async () => {
      await SplashScreen.hide();
    }, 3000);
  }
}
